export default { sha: '26dfd39ad6a46bd2eddef46c99b1203d7dcbc2c4', buildNumber: 'undefined' }
